/**
 * Global settings shared by all modules
 * @type {Object}
 */
var settings = module.exports = {
	breakpoints: {
		xs: 399,
		s: 450,
		m: 768,
		ml: 850,
		l: 930,
		xl: 1024,
		xxl: 1921,
		nav: 1240
	},
	animationSpeed: 200
};

settings.breakpoints.header = settings.breakpoints.nav;
